'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to specify a fallback image on an img if the src cannot be loaded.
 * Usage:
 * <img ng-src="missing-image.jpg" fallback-src="fallback-image.jpg">
 */
    .directive('fallbackSrc', function () {
        return {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                element.bind('error', function () {
                    angular.element(this).attr("src", attrs.fallbackSrc);
                });
            }
        }
    });